module.exports = __webpack_public_path__ + "static/WEDDING E&M-417-07bbf4c98a1c9699266d38acbaf03666.jpg";